import React from 'react';
import { Box, Spinner } from '../core';

export const LoadingOverlay = ({ loading }: { loading?: boolean }) =>
  loading ? (
    <Box
      sx={{
        position: 'absolute',
        height: '100%',
        width: '100%',
        opacity: 0.5,
        bg: 'background',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
    >
      <Spinner />
    </Box>
  ) : null;
